// Detecta coluna por palavras-chave
export function detectCol(cols, keys) {
  return cols.find(c => keys.some(k => c.toLowerCase().includes(k.toLowerCase()))) || null;
}

// Extrai mês/ano de string dd/mm/yyyy ou yyyy-mm-dd
export function extrairMesAno(val) {
  if (!val) return null;
  const s = String(val).trim();
  // dd/mm/yyyy
  const m1 = s.match(/^(\d{2})\/(\d{2})\/(\d{4})/);
  if (m1) return `${m1[3]}-${m1[2]}`;
  // yyyy-mm-dd
  const m2 = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m2) return `${m2[1]}-${m2[2]}`;
  return null;
}

export function labelMes(mesAno) {
  if (!mesAno) return '';
  const [y, m] = mesAno.split('-');
  const meses = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
  return `${meses[parseInt(m,10)-1]}/${y}`;
}

export const COLORS = ['#10b981','#6366f1','#f59e0b','#ef4444','#8b5cf6','#06b6d4','#ec4899','#f97316','#84cc16','#14b8a6'];

export const DS = {
  page:  { minHeight:'100vh', background:'linear-gradient(135deg,#0f172a 0%,#1e293b 50%,#0f172a 100%)', padding:'24px', fontFamily:"'Inter',sans-serif", color:'#e2e8f0' },
  card:  { background:'rgba(255,255,255,0.04)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'16px', padding:'20px', backdropFilter:'blur(10px)' },
  sel:   { padding:'8px 12px', borderRadius:'10px', background:'rgba(255,255,255,0.07)', border:'1px solid rgba(255,255,255,0.12)', color:'#e2e8f0', fontSize:'0.85rem', cursor:'pointer', outline:'none' },
  inp:   { padding:'8px 12px', borderRadius:'10px', background:'rgba(255,255,255,0.07)', border:'1px solid rgba(255,255,255,0.12)', color:'#e2e8f0', fontSize:'0.85rem', outline:'none' },
  label: { display:'block', fontSize:'0.68rem', color:'#64748b', fontWeight:700, textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'4px' },
  th:    { padding:'9px 10px', textAlign:'left', borderBottom:'1px solid rgba(255,255,255,0.08)', color:'#94a3b8', fontWeight:600, fontSize:'0.72rem', whiteSpace:'nowrap' },
  td:    { padding:'8px 10px', borderBottom:'1px solid rgba(255,255,255,0.04)', color:'#cbd5e1', maxWidth:180, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' },
  btn:   (bg, col='#fff') => ({ padding:'9px 18px', borderRadius:'10px', border:'none', fontWeight:700, fontSize:'0.85rem', cursor:'pointer', background:bg, color:col, transition:'all 0.2s' }),
};
